module.exports = __webpack_public_path__ + "static/media/ProConnect_Job_Aid.03081237.pdf";